



























import { Component, Vue } from 'vue-property-decorator';
import { Cookie, CookiePreferences } from '@/contract/cookies.contract';

@Component({})
export default class CookieBanner extends Vue {
  public showBanner = false;
  public cookiePreferences: CookiePreferences = {
    googleAnalyticsEnabled: false,
  };

  private bannerPopupDelay = 1500;
  private readonly maxCookieLifetime = '1y';

  public created() {
    setTimeout(() => {
      this.cookiePreferences = this.$cookies.get(Cookie.CookiePreferences);
      this.initialize();
    }, this.bannerPopupDelay);
  }

  public acceptAllAndInitialize() {
    this.cookiePreferences = this.acceptedAllCookiesPreferences;
    this.$cookies.set(Cookie.CookiePreferences, this.cookiePreferences, this.maxCookieLifetime);
    this.$cookies.set(Cookie.CookiePreferencesSaved, true, this.maxCookieLifetime);
    this.initialize();
  }

  public refuseAllAndInitialize() {
    this.cookiePreferences = this.refusedAllCookiesPreferences;
    this.$cookies.set(Cookie.CookiePreferences, this.cookiePreferences, this.maxCookieLifetime);
    this.$cookies.set(Cookie.CookiePreferencesSaved, true, this.maxCookieLifetime);
    this.initialize();
  }

  private initialize() {
    this.showBanner = !(this.$cookies.get(Cookie.CookiePreferencesSaved) === 'true');
    if (this.cookiePreferences?.googleAnalyticsEnabled) {
      this.$gtag.optIn();
    }
  }

  private acceptedAllCookiesPreferences: CookiePreferences = {
    googleAnalyticsEnabled: true,
  };

  private refusedAllCookiesPreferences: CookiePreferences = { googleAnalyticsEnabled: false };
}
